import { render, staticRenderFns } from "./shareForm.vue?vue&type=template&id=9bc44d9a&"
import script from "./shareForm.vue?vue&type=script&lang=js&"
export * from "./shareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports